export function parseLinkedElements(data) {
  let result = '';
  let count = 0;

  if (data && data.length) {
    result += 'Linked: ';
    data.forEach((ele, i) => {
      if (result.length < 160) {
        count += 1;
        if ((i + 1) !== data.length) {
          result += `${ele.description}, `;
        } else {
          result += ele.description;
        }
      }
    });
  }

  if (result.length >= 160) {
    return `${result} +${data.length - count}`;
  }

  return result;
}

export function parseTaggedUsersToComment(data) {
  let result = '';
  let count = 0;

  if (data && data.length) {
    result += 'Tagged: ';
    data.forEach((ele, i) => {
      if (result.length < 160) {
        count += 1;
        if ((i + 1) !== data.length) {
          result += `${ele.description}, `;
        } else {
          result += `${ele.description}`;
        }
      }
    });
  }

  if (result.length >= 160) {
    return `${result} +${data.length - count}`;
  }

  return result;
}

const actionCategories = {
  code: 'code',
  email: 'email',
  document: 'document',
  insuranceRequirement: 'insurance_requirement',
  requirementTemplate: 'requirement_template',
  requirementDocument: 'requirement_document',
  requirementProperty: 'requirement_property',
  policy: 'policy',
  insured: 'insured',
  job: 'job',
  attachment: 'attachment',
  agency: 'agency'
};

export const actionTypes = {
  documentUploaded: 'document_uploaded',
  documentArchived: 'document_archived',
  documentDeleted: 'document_deleted',
  documentReactivated: 'document_reactivated',
  documentLinked: 'document_linked',
  documentUpdated: 'document_updated',
  documentNameUpdated: 'document_name_updated',
  documentExpirationDateCreated: 'document_expiration_date_created',
  documentCloned: 'document_cloned',
  documentAutoArchived: 'document_auto_archived',
  documentLinksSuperseded: 'document_links_superseded',
  documentExpirationsCreated: 'document_expirations_created',
  documentExpirationCreated: 'document_expiration_created',
  documentExpirationUpdated: 'document_expiration_updated',
  documentExpirationDeleted: 'document_expiration_deleted',

  requirementCreated: 'insurance_requirement_created',
  requirementArchived: 'insurance_requirement_archived',
  requirementDetailsUpdated: 'insurance_requirement_details_updated',
  requirementUpdated: 'insurance_requirement_updated',
  requirementActivated: 'insurance_requirement_activated',
  requirementDeleted: 'insurance_requirement_deleted',
  requirementCloned: 'insurance_requirement_cloned',
  requirementCloneDispatched: 'insurance_requirement_clone_dispatched',
  requirementExpiredDataAutoArchived: 'insurance_requirement_expired_data_auto_archived',
  requirementCertificateSubmitted: 'insurance_requirement_certificate_submitted',

  requirementTemplateApplied: 'requirement_template_applied',

  requirementDocumentCompliant: 'requirement_document_compliant',
  requirementDocumentNonCompliant: 'requirement_document_non_compliant',
  requirementDocumentPending: 'requirement_document_pending',
  requirementDocumentWaived: 'requirement_document_waived',
  requirementDocumentRequired: 'requirement_document_required',
  requirementDocumentUploadedElsewhere: 'requirement_document_uploaded_elsewhere',

  requirementPropertyCompliant: 'requirement_property_compliant',
  requirementPropertyNonCompliant: 'requirement_property_non_compliant',
  requirementPropertyPending: 'requirement_property_pending',
  requirementPropertyWaived: 'requirement_property_waived',
  requirementPropertyNotReceived: 'requirement_property_not_received',

  codeApplied: 'code_applied',
  codeSuggested: 'code_suggested',
  codeWaived: 'code_waived',
  codeRemoved: 'code_removed',
  codeCleared: 'code_cleared',
  codeRemovalSuggested: 'code_removal_suggested',
  codeInquiring: 'code_inquired',
  emailSent: 'email_sent',
  policyCreated: 'policy_created',
  policyCloned: 'policy_cloned',
  policyUpdated: 'policy_updated',
  agentPolicyUpdated: 'policy_updated_agent',
  policyCanceled: 'policy_canceled',
  policyCompliant: 'policy_compliant',
  policyNonCompliant: 'policy_non_compliant',
  policyPending: 'policy_pending',
  policyWaived: 'policy_waived',
  policyArchived: 'policy_archived',
  policyAutoArchived: 'policy_auto_archived',
  policyDeleted: 'policy_deleted',
  policyExpired: 'policy_expired',
  policyReactivated: 'policy_reactivated',

  insuredCreated: 'insured_created',
  insuredUpdated: 'insured_updated',
  insuredArchived: 'insured_archived',
  insuredActivated: 'insured_activated',

  jobNameUpdated: 'job_name_updated',

  attachmentCreated: 'attachment_created',
  attachmentArchived: 'attachment_archived',
  attachmentDeleted: 'attachment_deleted',
  attachmentActivated: 'attachment_activated',

  agencyUpdated: 'agency_updated'
};

const actionTypeHeaders = {
  [actionTypes.codeApplied]: code => `applied code ${code} to`,
  [actionTypes.codeSuggested]: code => `suggested code ${code} for`,
  [actionTypes.codeWaived]: code => `waived code ${code} from`,
  [actionTypes.codeRemoved]: code => `removed code ${code} from`,
  [actionTypes.codeCleared]: code => `cleared code ${code} from`,
  [actionTypes.codeRemovalSuggested]: code => `suggested ${code} code removal for`,
  [actionTypes.codeInquiring]: code => `inquired about code ${code} for`,
  [actionTypes.emailSent]: () => 'sent email correspondence',

  [actionTypes.requirementCreated]: (requirement, job, message) => (
    message
      ? `created record ${requirement.contractNumber ? `# ${requirement.contractNumber}` : ''} on ${job.name}:`
      : `created record ${requirement.contractNumber ? `# ${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementDetailsUpdated]: (requirement, job) => (
    `updated details of record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementUpdated]: (requirement, job, message) => (
    message
      ? `updated requirements of record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}:`
      : `updated requirements of record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementArchived]: (requirement, job) => (
    `archived insured's record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementActivated]: (requirement, job) => (
    `activated insured's record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementDeleted]: (requirement, job) => (
    `deleted insured's record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''} on ${job.name}`
  ),
  [actionTypes.requirementCloned]: (requirement, job) => (
    'cloned the following policies and documents:'
  ),
  [actionTypes.requirementCloneDispatched]: (requirement, job) => (
    `cloned insurance from record ${requirement?.contractNumber ? `#${requirement.contractNumber} ` : ''}on ${job?.name} to other records:`
  ),
  [actionTypes.requirementExpiredDataAutoArchived]: (requirement, job) => (
    `auto archived expired data on record ${requirement?.contractNumber ? `#${requirement.contractNumber} ` : ''}on ${job?.name}:`
  ),
  [actionTypes.requirementCertificateSubmitted]: (requirement, job) => (
    `submitted a certificate on record ${requirement?.contractNumber ? `#${requirement.contractNumber} ` : ''}on ${job?.name}:`
  ),
  [actionTypes.requirementTemplateApplied]: (template, requirement, job) => (
    `applied requirement template ${template.name} to ${job.name} record ${requirement.contractNumber ? `#${requirement.contractNumber}` : ''}`
  ),
  [actionTypes.requirementDocumentCompliant]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as compliant`),
  [actionTypes.requirementDocumentNonCompliant]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as non-compliant`),
  [actionTypes.requirementDocumentPending]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as pending`),
  [actionTypes.requirementDocumentWaived]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as waived`),
  [actionTypes.requirementDocumentRequired]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as required`),
  [actionTypes.requirementDocumentUploadedElsewhere]: requirementDocument => (
    `marked "${requirementDocument.documentType?.displayName}" requirement as uploaded elsewhere`),

  [actionTypes.requirementPropertyCompliant]: requirementProperty => (
    `marked "${requirementProperty.policyType?.displayName}" requirement as compliant`),
  [actionTypes.requirementPropertyNonCompliant]: requirementProperty => (
    `marked "${requirementProperty.policyType?.displayName}" requirement as non-compliant`),
  [actionTypes.requirementPropertyPending]: requirementProperty => (
    `marked "${requirementProperty.policyType?.displayName}" requirement as pending`),
  [actionTypes.requirementPropertyWaived]: requirementProperty => (
    `marked "${requirementProperty.policyType?.displayName}" requirement as waived`),
  [actionTypes.requirementPropertyNotReceived]: requirementProperty => (
    `marked "${requirementProperty.policyType?.displayName}" requirement as required`),

  [actionTypes.documentUploaded]: (document, message) => (message ? 'uploaded a document:' : `uploaded document: ${document?.originalName || ''}`),
  [actionTypes.documentArchived]: (document, message) => (message ? 'archived a document:' : `archived document: ${document?.originalName || ''}`),
  [actionTypes.documentReactivated]: (document, message) => (message ? 'reactivated a document:' : `reactivated document: ${document?.originalName || ''}`),
  [actionTypes.documentDeleted]: (document, message) => (message ? 'deleted a document:' : `deleted document: ${document?.originalName || ''}`),
  [actionTypes.documentLinked]: (document, message) => (message ? 'updated a document\'s linked policies:' : `updated document ${document?.originalName}'s linked policies`),
  [actionTypes.documentExpirationDateCreated]: (document, message) => (
    message ? 'updated a document\'s expiration date:' : `updated document ${document?.originalName}'s expiration date`
  ),
  [actionTypes.documentCloned]: document => (
    `cloned document ${document?.originalName}`
  ),
  [actionTypes.documentUpdated]: document => (
    `updated document ${document?.originalName}`
  ),
  [actionTypes.documentNameUpdated]: document => (
    `updated document name. Original name: ${document?.originalName}. New name: ${document?.displayName}`
  ),
  [actionTypes.documentAutoArchived]: document => `auto archived the expired document: ${document?.originalName}, with a newly created document`,
  [actionTypes.documentLinksSuperseded]: document => `retired expired links on the document: ${document?.originalName}, replaced by a newer document`,
  [actionTypes.documentExpirationsCreated]: (document, message) => (
    message ? 'added expiration dates to a document:' : `added expiration dates to document ${document?.originalName}`
  ),
  [actionTypes.documentExpirationCreated]: (document, message) => (
    message ? 'added an expiration date to a document:' : `added an expiration date to document ${document?.originalName}`
  ),
  [actionTypes.documentExpirationUpdated]: (document, message) => (
    message ? 'updated an expiration date on a document:' : `updated an expiration date on document ${document?.originalName}`
  ),
  [actionTypes.documentExpirationDeleted]: (document, message) => (
    message ? 'removed an expiration date from a document:' : `removed an expiration date from document ${document?.originalName}`
  ),

  [actionTypes.policyCompliant]: policy => `marked policy as compliant: #${policy?.number}`,
  [actionTypes.policyNonCompliant]: policy => `marked policy as non-compliant: #${policy?.number}`,
  [actionTypes.policyPending]: policy => `marked policy as pending: #${policy?.number}`,
  [actionTypes.policyWaived]: policy => `marked policy as waived: #${policy?.number}`,
  [actionTypes.policyCreated]: (policy, message) => (message ? 'submitted a policy:' : `submitted policy: #${policy?.number}`),
  [actionTypes.policyCloned]: policy => `cloned policy: #${policy?.number}`,
  [actionTypes.policyArchived]: (policy, message) => (message ? 'archived a policy:' : `archived policy: #${policy?.number}`),
  [actionTypes.policyAutoArchived]: (policy, message) => (message ? 'auto archived an expired policy:' : `auto archived the expired policy: #${policy?.number}`),
  [actionTypes.policyUpdated]: (policy, message) => (message ? 'updated a policy:' : `updated policy: #${policy?.number}`),
  [actionTypes.agentPolicyUpdated]: (policy, message) => (message ? 'updated an agent\'s policy:' : `updated an agent's policy: #${policy?.number}`),
  [actionTypes.policyDeleted]: (policy, message) => (message ? 'deleted a policy:' : `deleted policy: #${policy?.number}`),
  [actionTypes.policyReactivated]: (policy, message) => (message ? 'reactivated a policy:' : `policy reactivated: #${policy?.number}`),
  [actionTypes.policyCanceled]: (policy, message) => (message ? 'reactivated a policy:' : `canceled policy: #${policy?.number}`),
  [actionTypes.policyExpired]: (policy, message) => (message ? 'policy expired' : `policy expired: #${policy?.number}`),

  [actionTypes.insuredCreated]: insured => `created ${insured.companyName}`,
  [actionTypes.insuredUpdated]: insured => 'updated insured details',
  [actionTypes.insuredActivated]: insured => `reactivated ${insured.companyName}`,
  [actionTypes.insuredArchived]: insured => `archived ${insured.companyName}`,

  [actionTypes.jobNameUpdated]: (requirement, job) => `updated project name to ${job.name}`,

  [actionTypes.attachmentCreated]: (requirement, attachment) => `added attachment: ${attachment?.name}`,
  [actionTypes.attachmentArchived]: (requirement, attachment) => `archived attachment: ${attachment?.name}`,
  [actionTypes.attachmentDeleted]: (requirement, attachment) => `deleted attachment: ${attachment?.name}`,
  [actionTypes.attachmentActivated]: (requirement, attachment) => `activated attachment: ${attachment?.name}`,

  [actionTypes.agencyUpdated]: agency => 'updated agency details'
};

export const getActionTypeHeader = (activity, message = null) => {
  const labelBuilder = actionTypeHeaders[activity.action] || (() => `Invalid action ${activity.action}`);

  if (activity.action.startsWith(actionCategories.code)) {
    const codeLetter = activity.code?.letter || '';
    const itemType = activity.item?.type || 'item';

    if (activity.count) {
      return `${labelBuilder(codeLetter)} ${activity.count} ${itemType}s`;
    }

    const itemIdentifier = activity.item?.properties?.find(p => p.name === 'unit_number')?.value;
    return `${labelBuilder(codeLetter)} ${itemType} ${itemIdentifier}`;
  }

  if (activity.action.startsWith(actionCategories.email)) {
    return `${labelBuilder()}`;
  }

  if (activity.action.startsWith(actionCategories.requirementDocument)) {
    const { insuranceRequirementDocument } = activity;
    return `${labelBuilder(insuranceRequirementDocument)}`;
  }

  if (activity.action.startsWith(actionCategories.requirementProperty)) {
    const { insuranceRequirementProperty } = activity;
    return `${labelBuilder(insuranceRequirementProperty)}`;
  }

  if (activity.action.startsWith(actionCategories.document)) {
    const { insuranceDocument } = activity;
    return `${labelBuilder(insuranceDocument, message)}`;
  }

  if (activity.action.startsWith(actionCategories.policy)) {
    const { insurancePolicy } = activity;
    return `${labelBuilder(insurancePolicy, message)}`;
  }

  if (activity.action.startsWith(actionCategories.insured)) {
    const { insured } = activity;
    return `${labelBuilder(insured)}`;
  }

  if (activity.action.startsWith(actionCategories.insuranceRequirement)) {
    const { insuranceRequirement, job } = activity;
    return `${labelBuilder(insuranceRequirement, job, message)}`;
  }

  if (activity.action.startsWith(actionCategories.job)) {
    const { insuranceRequirement, job } = activity;
    return `${labelBuilder(insuranceRequirement, job)}`;
  }

  if (activity.action.startsWith(actionCategories.requirementTemplate)) {
    const { requirementTemplate, insuranceRequirement, job } = activity;
    return `${labelBuilder(requirementTemplate, insuranceRequirement, job)}`;
  }

  if (activity.action.startsWith(actionCategories.attachment)) {
    const { insuranceRequirement, attachment } = activity;
    return `${labelBuilder(insuranceRequirement, attachment)}`;
  }

  if (activity.action.startsWith(actionCategories.agency)) {
    const { agency } = activity;
    return `${labelBuilder(agency)}`;
  }

  return '';
};
